import MeshIcon from './component'

export default MeshIcon
